import React from 'react';

interface NotesEditorProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  placeholder?: string;
}

export const NotesEditor: React.FC<NotesEditorProps> = ({
  value,
  onChange,
  onBlur,
  autoFocus,
  placeholder = 'Notes...',
}) => {
  return (
    <textarea
      className="item-notes-input"
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      autoFocus={autoFocus}
      placeholder={placeholder}
      rows={2}
    />
  );
};
